'use client'

import { FetchWrapperComponent } from '@/src/common//fetch/custom.fetch'
import { useReturnUrl } from '@/src/components/auth/return.url.component'
import { useVariables } from '@/src/components/context/variable.context'
import { ReactNode, useCallback } from 'react'

export default function LayoutContext(params: { children: ReactNode }) {
  if (params?.children) {
    // eslint-disable-next-line react/no-children-prop
    return <LayoutContextInner children={params.children} />
  }

  return <></>
}

function LayoutContextInner(params: { children: ReactNode }) {
  const returnUrl = useReturnUrl()
  const { backendUrl } = useVariables()

  const afterRequest = useCallback(async (url: string, options: RequestInit, response: Response) => {
    if (typeof window !== 'undefined' && window.location.href.includes('/p/')) {
      return response
    }

    const logout = response?.headers?.get('logout') || response?.headers?.get('Logout')

    if (logout) {
      // TODO: remove cookies
      window.location.href = '/'
      return response
    }

    if (response.status === 401) {
      // TODO: logout
      window.location.href = '/'
    }

    if (response.status === 402) {
      // TODO: handle payment required
      //   if (await deleteDialog((await response.json()).message, 'Move to billing', 'Payment Required')) {
      //     window.open('/billing', '_blank')
      //   }
      // return false
    }

    return response
  }, [])

  return (
    <FetchWrapperComponent baseUrl={backendUrl} afterRequest={afterRequest}>
      {params?.children || <></>}
    </FetchWrapperComponent>
  )
}
